import React from "react";
import Cards from "../components/cards";
import SEO from "../components/SEO";

function Home() {
  return (
    <>
      <SEO 
        title="Próteses e Órteses Sob Medida"
        description="São José Ortopédicos - Há mais de 30 anos oferecendo próteses e órteses sob medida em Teresópolis, Nova Friburgo e Cabo Frio. Oficina ortopédica credenciada."
        keywords="próteses, órteses, ortopedia, teresópolis, nova friburgo, cabo frio, oficina ortopédica, produtos ortopédicos"
        canonicalUrl="https://www.saojoseortopedicos.com.br/"
      />
      <Cards />
    </>
  );
}

export default Home;